module.exports = __webpack_public_path__ + "europa-20-signature.jpg?fc1d1d4fdc8acec1ac930501d3d2d380";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20-signature.jpg
// module id = 301
// module chunks = 0